if (!window.Eurus.loadedScript.includes('lp-naruto.js')) {
    window.Eurus.loadedScript.push('lp-naruto.js');
}
const deferScriptLoad = (name, src, onload, requestVisualChange = false) => {
    window.Eurus.loadedScript.push(name);
    (events => {
        const loadScript = () => {
            events.forEach(type => window.removeEventListener(type, loadScript));
            clearTimeout(autoloadScript);
            const initScript = () => {
                const script = document.createElement('script');
                script.setAttribute('src', src);
                script.setAttribute('defer', '');
                script.onload = () => {
                    document.dispatchEvent(new CustomEvent(name + ' loaded'));
                    onload();
                };
                document.head.appendChild(script);
            };
            if (requestVisualChange) {
                if (window.requestIdleCallback) {
                    requestIdleCallback(initScript);
                }
                else {
                    requestAnimationFrame(initScript);
                }
            }
            else {
                initScript();
            }
        };
        let autoloadScript;
        if (window.Shopify && window.Shopify.designMode) {
            loadScript();
        }
        else {
            const wait = window.innerWidth > 767 ? 2000 : 5000;
            events.forEach(type => window.addEventListener(type, loadScript, { once: true, passive: true }));
            autoloadScript = setTimeout(() => {
                loadScript();
            }, wait);
        }
    })(['touchstart', 'mouseover', 'wheel', 'scroll', 'keydown']);
};
// alpine func
requestAnimationFrame(() => {
    document.addEventListener('alpine:init', () => {
        // toggle data
        Alpine.data('lpToggle', () => ({
            open: false,
            toggleBtn: {
                ['@click']() { this.open = !this.open; },
                ['x-init']: `$watch('open', value => $refs.btnText.textContent = open ? 'Close' : 'View more')`,
            },
            btnLabel: {
                ['x-ref']: 'btnText',
            },
            toggleContent: {
                ['x-cloak']: '',
                ['x-show']() { return this.open; },
                ['x-transition:enter.opacity.duration.500ms']: '',
                ['x-transition:leave.opacity.duration.250ms']: '',
            },
        }));
        // mobile nav
        Alpine.store('lpMobileNav', {
            show: false,
            toggle() {
                this.show = !this.show;
            },
            close() {
                this.show = false;
            }
        });
    });
});
